
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, RefreshCw } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

interface ActionButtonsProps {
  handleRestartQuiz: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({ handleRestartQuiz }) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const handleNavigateHome = () => {
    navigate('/');
  };

  return (
    <div className={`mt-8 flex ${isMobile ? 'flex-col' : 'flex-row'} items-center justify-center gap-4`}>
      <Button 
        onClick={handleRestartQuiz}
        variant="outline"
        className="w-full md:w-auto flex items-center gap-2 transition-all hover:bg-secondary"
      >
        <RefreshCw size={16} />
        <span>Retake Assessment</span>
      </Button>
      
      <Button 
        onClick={handleNavigateHome}
        variant="secondary"
        className="w-full md:w-auto flex items-center gap-2 transition-all hover:scale-105"
      >
        <ArrowLeft size={16} />
        <span>Back to Home</span>
      </Button>
    </div>
  );
};

export default ActionButtons;
